import { render } from "./privacy-policy.vue?vue&type=template&id=2744aa06&scoped=true"
import script from "./privacy-policy.vue?vue&type=script&lang=js"
export * from "./privacy-policy.vue?vue&type=script&lang=js"

import "./privacy-policy.vue?vue&type=style&index=0&id=2744aa06&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2744aa06"]])

export default __exports__